// extracted by mini-css-extract-plugin
module.exports = {"klarnaPaymentMessage__block":"KlarnaPaymentMessage_klarnaPaymentMessage__block__d1j50","klarnaPaymentMessage__spinner":"KlarnaPaymentMessage_klarnaPaymentMessage__spinner__wchLT"};